/**
 * Escudos y nombres del header resumen/minuto desde `data.matchCard[0].summary.matchDetails`.
 * Sin data del servicio no se devuelve fallback (no iconos mock).
 * @param {object|undefined} matchDetailsData — cuerpo `data` del servicio.
 * @returns {{ home: { name: string, alt: string, badgeUrl: string } | null, away: { name: string, alt: string, badgeUrl: string } | null }}
 */
function mapResumenHeaderTeam(team) {
  if (!team) return null;

  const name = team?.name?.trim() || '';
  const badgeUrl =
    team?.crestUrl && String(team.crestUrl).trim()
      ? String(team.crestUrl).trim()
      : '';

  if (!name && !badgeUrl) return null;

  return {
    name,
    alt: name,
    badgeUrl,
  };
}

export function getResumenHeaderTeamsFromMatchDetails(matchDetailsData) {
  const md = matchDetailsData?.matchCard?.[0]?.summary?.matchDetails;
  return {
    home: mapResumenHeaderTeam(md?.home?.team),
    away: mapResumenHeaderTeam(md?.away?.team),
  };
}
